import React, { useEffect, useState } from 'react';
import { Menu } from '../../ui/layout/Menu';
import useApi from '../../hooks/useApi';
import { userState } from '../../store';
import { useSnapshot } from 'valtio';
import { FooterCmp } from '../../ui/layout/Footer';
import { PageHeader } from '../../ui/ds/PageHeader';
import { Card } from '../../ui/ds/Card';
import { Btn } from '../../ui/ds/Btn';
import { Badge } from '../../ui/ds/Badge';

export const EntryFee = () => {
    const userSnap = useSnapshot(userState);
    const [paymentQRCode, setPaymentQRCode] = useState<string>('');
    const { backend } = useApi(true);

    useEffect(() => {
        if (userSnap.isLoggedIn) {
            backend.user.userControllerUserPaymentQrCode().then((res: string) => {
                setPaymentQRCode(res);
            });
        }
    }, [userSnap.isLoggedIn]);

    if (!userSnap.isLoggedIn) {
        return (
            <><Menu /><div className="max-w-md mx-auto px-4 py-16 text-center"><p className="tb-h2 text-text-primary">Je vyžadováno přihlášení</p></div></>
        );
    }

    const downloadQR = () => {
        const link = document.createElement('a');
        link.href     = paymentQRCode;
        link.download = 'tipbuddy_qrplatba.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <Menu />
            <PageHeader
                title="Vstupní poplatek"
                subtitle="Zaplaťte poplatek a začněte tipovat"
                variant="orange"
            />

            <div className="max-w-2xl mx-auto px-4 md:px-8 py-6 flex flex-col gap-4">
                {/* Info banner */}
                <div className="flex gap-3 bg-brand-blue/10 border border-brand-blue/20 rounded-content px-4 py-4">
                    <span className="text-[20px] flex-shrink-0">💳</span>
                    <div>
                        <p className="tb-h4 text-text-primary mb-1">O vstupním poplatku</p>
                        <p className="tb-body text-text-muted">
                            Vstupní poplatek je určen hlavně na výhry pro účastníky, část peněz jde na provoz systému.
                            Po zaplacení vstupného získáte možnost tipovat zápasy a získávat body do žebříčku.
                        </p>
                    </div>
                </div>

                {!userSnap.userProfile?.entryFeePaid ? (
                    <Card>
                        <h2 className="tb-h2 text-text-primary mb-5">Způsob platby</h2>
                        <div className="flex flex-col md:flex-row gap-8 items-start">
                            {/* QR code */}
                            <div className="flex flex-col items-center gap-3 flex-shrink-0">
                                {paymentQRCode && (
                                    <img src={paymentQRCode} alt="QR platba" className="w-40 h-40 rounded-content" />
                                )}
                                <p className="tb-caption">QR Platba</p>
                                <Btn variant="outline" size="sm" onClick={downloadQR}>
                                    Stáhnout QR kód
                                </Btn>
                            </div>

                            {/* Payment details */}
                            <div className="flex flex-col gap-3">
                                <div className="flex flex-col gap-1">
                                    <p className="tb-label">Částka</p>
                                    <p className="tb-h3 text-text-primary">100 Kč</p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <p className="tb-label">Číslo účtu</p>
                                    <p className="tb-body text-text-primary font-black">340013836/0300</p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <p className="tb-label">Variabilní symbol</p>
                                    <p className="tb-h3 text-brand-blue">{userSnap.userProfile?.entryFeeVS}</p>
                                </div>
                                <p className="tb-caption italic">
                                    Platbu je možné odevzdat i osobně pověřené osobě.
                                </p>
                                <div className="mt-2 p-3 bg-bg-inputSoft rounded-card">
                                    <p className="tb-caption text-text-muted">
                                        Po připsání platby na účet systém automaticky zaznamená zaplacení vstupného
                                        a zpřístupní tipování zápasů. (Připsání může trvat až 3 hodiny.)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>
                ) : (
                    <Card className="text-center py-10">
                        <div className="text-[48px] mb-4">✅</div>
                        <h2 className="tb-h2 text-text-primary mb-2">Vstupní poplatek zaplacen</h2>
                        <p className="tb-body text-text-muted mb-4">
                            Máte možnost tipovat zápasy a získávat body do žebříčku.
                        </p>
                        <Badge variant="success">Zaplaceno</Badge>
                    </Card>
                )}
            </div>

            <FooterCmp />
        </>
    );
};
